import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {AXIOS_CANCEL_MSG, ProductionLineWithEvents} from '../api/models';
import { ConfiguratorContext } from '../context';

interface MasterScheduleEventListProps {
  productionLines: string[] | undefined
  startDate: string | undefined
  endDate: string | undefined
}

export const useMasterScheduleEvents = (props: MasterScheduleEventListProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:MasterScheduleEventListProps  ) : Promise<ProductionLineWithEvents[] | undefined> => {
    if ( !props.productionLines?.length ) return;
    if ( !props.startDate ) return;
    if ( !props.endDate ) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.getMasterScheduleEvents(props.productionLines, props.startDate, props.endDate, cancelSource.token );
      cancelTokenSourceRef.current = undefined;

      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  }

  // Use SWR for data fetching
  return useSWR([
    'getMasterScheduleEvents',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      //maybe unnecessary
      revalidateOnFocus: false,
      //maybe unnecessary
      dedupingInterval:1 
    }
  );
};


export default useMasterScheduleEvents;

